import gate from '@/api/axios';

/**
 * Получает список объектов
 * @async
 * @function objectsSearch
 * @param {Object} payload
 * @returns {Promise}
 */
export const objectsSearch = async (payload) => gate.get('/subjects', {
  params: payload,
});

/**
 * Получает модель объекта
 * @async
 * @function objectDetails
 * @param {Object} payload
 * @returns {Promise}
 */
export const objectDetails = async (id) => gate.get(`/subjects/${id}`);

/**
 * Создает новый объект
 * @async
 * @function objectCreate
 * @param {Object} payload
 * @returns {Promise}
 */
export const objectCreate = async (payload) => gate.post('/subjects', payload);

/**
 * Редактирует объект
 * @async
 * @function objectUpdate
 * @param {Number|String} id ID объекта
 * @param {Object} payload
 * @returns {Promise}
 */
export const objectUpdate = async (id, payload) => gate.patch(`/subjects/${id}`, payload);

/**
 * Получает список заказов объекта
 * @async
 * @function objectOrders
 * @param {Number|String} id ID объекта
 * @param {Object} payload
 * @returns {Promise}
 */
export const objectOrders = async (id, payload) => gate.get(`/subjects/${id}/searchOrders`, {
  params: payload,
});

/**
 * Блокировка и разблокировка объекта
 * @async
 * @function setObjectBlocking
 * @param {Number|String} id ID объекта
 * @param {Number|String} reason Причина блокировки
 * @returns {Promise}
 */
export const setObjectBlocking = async (id, reason) => gate.post(`/subjects/${id}/blocking`, {
  reason,
});

/**
 * Импорт CSV объектов
 * @async
 * @function importCsv
 * @param {FormData} fd
 * @returns {Promise}
 */
export const importCsv = async (fd) => gate.post('/subjects/importCsv', fd, {
  headers: {
    'Content-Type': 'text/csv',
  },
});

/**
 * Импорт списка кладбищ
 * @async
 * @function importCsv
 * @param {FormData} fd
 * @returns {Promise}
 */
export const importCemeteries = async (fd) => gate.post('/cemeteries/import', fd, {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});

/**
 * Удаление объекта
 * @async
 * @function objectDelete
 * @param {Number|String} id ID объекта
 * @returns {Promise}
 */
export const objectDelete = async (id) => gate.delete(`/subjects/${id}`);
